import { useCallback, useEffect, useRef, useState } from "react";

export function useAutoHide() {
  const [isVisible, setIsVisible] = useState(true);
  const timeoutRef = useRef<number | undefined>(undefined);

  const show = useCallback((durationMs: number) => {
    window.clearTimeout(timeoutRef.current);
    setIsVisible(true);
    timeoutRef.current = window.setTimeout(
      () => setIsVisible(false),
      durationMs,
    );
  }, []);
  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);
  return { isVisible, show };
}
